module.exports = "<div class=\"pOne d-none d-sm-block mb-20\" data-slnm-ihg='hotelAddressSID'>\n  <span data-slnm-ihg='hotelAddressStreet1SID' [innerText]=\"address?.street1\"></span><br>\n  <span data-slnm-ihg='hotelAddressCitySID' [innerText]=\"address?.city\"></span>\n  <span data-slnm-ihg='hotelAddressStateSID' [innerText]=\"address?.stateName\"></span>\n  <span data-slnm-ihg='hotelAddressZipSID' [innerText]=\"address?.zipCode\"></span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/hotel-address/hotel-address.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/hotel-address/hotel-address.component.html
// module chunks = 0